import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getAISuggestedKeywordByString: {
    method: 'GET',
    url: `${configs.baseUrl}/api/generative-ai/keyword:generate`,
  },
  getAISuggestedKeywordByContent: {
    method: 'POST',
    url: `${configs.baseUrl}/api/keyword`,
  },
  getAISuggestedKeywordByPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/presentation:generate-keyword`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAISuggestedKeywordByString = async (string) => {
  const res = await resource.getAISuggestedKeywordByString(string)
  return res.body
}

const getAISuggestedKeywordByContent = async (params) => {
  const res = await resource.getAISuggestedKeywordByContent(params)
  return res.body
}
const getAISuggestedKeywordByPresentation = async (params) => {
  const res = await resource.getAISuggestedKeywordByPresentation(params)
  return res.body
}

export default {
  initResource,

  getAISuggestedKeywordByString,
  getAISuggestedKeywordByContent,
  getAISuggestedKeywordByPresentation,
}
